import firebase from 'firebase';
var constants = require('../config/constants');
import React from 'react';
import { Router, Route, browserHistory } from 'react-router';

var provider = new firebase.auth.GoogleAuthProvider();

var listeners = [];

var auth = {};

auth.userData = null;

auth.init = function() {
  firebase.initializeApp(constants.firebaseConfig);

  firebase.auth().onAuthStateChanged(firebaseUser => {
    auth.getUser().then(user => {
      auth.notifyUserChange(firebaseUser);
    });
  });
}

auth.notifyUserChange = (user) => {
  for (var listenerIdx in listeners) {
    if (typeof(listeners[listenerIdx]) === 'function') {
      listeners[listenerIdx](user);
    }
  }
}

auth.currentUser = function() {
  return firebase.auth().currentUser;
}

auth.getToken = function() {
  var user = auth.currentUser();
  return user && user != null ? user.getToken() : new Promise((resolve, reject) => reject());
}

auth.addListener = function(listener) {
  listeners.push(listener);
}

auth.login = function() {
  return new Promise((resolve, reject) => {
    firebase.auth().signInWithPopup(provider).then(result => {
      auth.getUser().then(user => {
        console.log("setting user data...");
        auth.userData = user;
        console.log("user data ok");
        auth.notifyUserChange(auth.currentUser);
        resolve(user);
      }).catch(error => {
        auth.logout();
        auth.userData = undefined;
        reject(error);
      });
    }).catch(error => {
      auth.logout();
      reject(error);
    });
  });
}

auth.getUser = () => {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/users/me', {
        headers: {
          'x-alueluettelo-auth': token
        }
      }).then(response => {
          if (response.status == 401) {
            reject(null);
          } else {
            response.json().then(user => {
              console.log(user);
              if (user && user != null) {
                console.log("has user! resolve()");
                auth.userData = user;
                resolve(user);
              } else {
                console.log("no user");
                reject(null);
              }
            });
          }
        }).catch(error => {
          reject(error);
        });
      });
    });
}

auth.hasLocalStorageUser = function() {
  let hasLocalStorageUser = false;
  for (let key in localStorage) {
      if (key.startsWith("firebase:authUser:")) {
          hasLocalStorageUser = true;
      }
  }
  return hasLocalStorageUser;
}

auth.logout = function() {
  return firebase.auth().signOut();
}

auth.requireAuth = function (nextState, replace) {
  var hasUser = auth.hasLocalStorageUser();
  var currentUser = auth.currentUser();
  var validUser = (currentUser && currentUser != null) ? true : false;

  if (!validUser && !hasUser) {
      replace({
          pathname: '/login',
          state: { nextPathname: nextState.location.pathname }
      });
  }
};

module.exports = auth;



// WEBPACK FOOTER //
// ./src/service/auth.js